<template>
  <div class="player-stats">
    <div class="row">
      <PlayerStat @update="updateStat" :item-slot="'attack'" @potionUpdate="potionUpdate" :potions="potions.attack"
                  :active-potion="activePotions.attack" :boost="boosts.attack" :icon="'attack'"
                  :value="stats.attack.level" class="col-12 mb-1"></PlayerStat>
      <PlayerStat @update="updateStat" :item-slot="'strength'" @potionUpdate="potionUpdate" :potions="potions.strength"
                  :active-potion="activePotions.strength" :boost="boosts.strength" :icon="'strength'"
                  :value="stats.strength.level" class="col-12 my-1"></PlayerStat>
      <PlayerStat @update="updateStat" :item-slot="'defence'" @potionUpdate="potionUpdate" :potions="potions.defence"
                  :active-potion="activePotions.defence" :icon="'defence'" :value="stats.defence.level"
                  class="col-12 my-1"></PlayerStat>
      <PlayerStat @update="updateStat" :item-slot="'ranged'" @potionUpdate="potionUpdate" :potions="potions.ranged"
                  :active-potion="activePotions.ranged" :boost="boosts.ranged" :icon="'ranged'"
                  :value="stats.ranged.level" class="col-12 my-1"></PlayerStat>
      <PlayerStat @update="updateStat" :item-slot="'magic'" @potionUpdate="potionUpdate" :potions="potions.magic"
                  :active-potion="activePotions.magic" :boost="boosts.magic" :icon="'magic'" :value="stats.magic.level"
                  class="col-12 my-1"></PlayerStat>
      <PlayerStat :icon="'prayer'" :value="stats.prayer.level" class="col-12 my-1"></PlayerStat>
      <PlayerStat @update="updateHitpointStat" :icon="'hitpoints'" :value="stats.hitpoints.level"
                  class="col-12 mt-1"></PlayerStat>
    </div>

  </div>
</template>

<script>
  import PlayerStat from "./PlayerStat";
  import Combat from "./stats/Combat";

  export default {
    name: "PlayerStats",
    components: {Combat, PlayerStat},
    props: {
      boosts: {
        type: Object
      },
      activePotions: {
        type: Object
      },
      stats: {
        type: Object,
        default: function () {
          return {
            hitpointsLost: 0,
            attack: {level: 0},
            strength: {level: 0},
            defence: {level: 0},
            ranged: {level: 0},
            prayer: {level: 0},
            magic: {level: 0},
            hitpoints: {level: 0},
          }
        }
      }
    },
    data() {
      return {
        potions: {
          attack: require('@/assets/data/potions/attack.json'),
          strength: require('@/assets/data/potions/strength.json'),
          ranged: require('@/assets/data/potions/ranged.json'),
          magic: require('@/assets/data/potions/magic.json'),
        }
      }
    },
    computed: {},
    methods: {
      potionUpdate: function (itemSlot, potion) {
        console.log("playerstats potion update", itemSlot, potion);
        this.activePotions[itemSlot] = potion;
        this.$emit('potionUpdate', this.activePotions);
      },
      updateStat: function (stat, value) {
        console.log('Updating stats', {stat: stat, value: value});
        this.$set(this.stats[stat], 'level', value)
      },
      updateHitpointStat: function (stat, value) {
        console.log('Updating stats', {stat: stat, value: value});
        this.$set(this.stats, 'hitpointsLost', value);
        this.$emit('potionUpdate', this.activePotions); //Trigger update
      }
    },
  }
</script>

<style scoped>
  .player-stat {
    /*border: 1px solid blue;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/PlayerStats.vue